import { useModal } from 'naive-ui'

const ModalContent = () => {
  const modal = useModal()

  window.$modal = modal

  return <></>
}

export default ModalContent
